import { useEffect } from "react";

const SITE_URL = import.meta.env.VITE_SITE_URL || "http://localhost:5173";

export function usePageMeta(title: string, description: string, path = "/") {
  useEffect(() => {
    document.title = title;
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    canonical?.setAttribute("href", `${SITE_URL}${path === "/" ? "" : path}`);
    const descriptionTag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    descriptionTag?.setAttribute("content", description);
  }, [description, path, title]);
}
